import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { KmsService } from '../../../kms.service';
import { NgForm } from '@angular/forms';
import { SwModalframeComponent } from '../../../../../librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component';
import { InstanceModuleService } from '../../../serves/instance/instance.module';
import { SwTabService } from '../../../../../librarys/serves/public/sw-tab.service';
import { DictionaryService } from '../../../../../librarys/serves/public/dictionary.service';
import { SwMassageBoxService } from '../../../../../librarys/serves/sw-massage-box.service';
import { SwCreateModalComponentService } from '../../../../../librarys/serves/sw-create-modal-component.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';

import { KmgMapComponent} from '../../../components/kmg-map/kmg-map.component';
import { KmsEnum } from '../../../serves/kms-enum';
import { SwJwtService } from 'src/app/librarys/serves/sw-jwt.service';
import { GetUserModelService } from 'src/app/librarys/serves/public/get-user-model.service';
import { EditDatasourceComponent } from '../../../components/edit-datasource/edit-datasource.component';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { environment } from 'src/environments/environment';
declare var $;
declare var CKEDITOR: any; 
@Component({
    selector: 'app-instance-add',
    templateUrl: './instance-add.component.html',
    styleUrls: ['./instance-add.component.css']
})
export class InstanceAddComponent implements OnInit {

    // 是否显示正在加载中
    isLoading = false;
    // 路由参数
    params = {
        addOrUpdate: '',
        instanceId: '',  // 实体id(用于切换tab导航和新增其他信息时的判断)
        conceptId: '',
        instanceName: '',
        serialNumber: '',
        conceptName: '',
        type: 1,
    };
    // 封面图上传文件策略
    autoCode:string = '';
    // 封面图
    fileThumbnail:string = '';

    // 概念模型树，默认不可选中的父级概念结点
    readonlySelfIds = [];
    // 概念模型树数据
    ontologyTreeDatas = [];
    // 头部概念选中code
    activeTreeCode: any = '';
    mapping: string = '';

    // 头部表单是否可以操作编辑
    isTopFormTabEdit = false;

    // 头部实体名称验证
    instanceNameValidator = {
        isInit: true,
        isValid: true
    };

    // 头部已选择的标签数组
    selectedTags: any = [];

    // 高级属性表单结构，用来渲染表单
    baseInfoConfig = [];

    // 表单，三元组数据所需数据结构
    tripleFormDatas = [];

    // 头部搜索到的实体列表
    instanceDatasList = [];

    // 头部实体列表选中索引值
    activeInstanceIndex = -1;

    // tab选项卡配置
    multipleAttribute = [];
    // 其它属性表单结构（如生平、流传、修复等）
    compositeAttributes = [];

    // 特殊属性表单结构（如时间，时间备注等）
    specialDatas = [];

    // 表单地理位置信息选择索引值
    mapFormSelectedIndex = -1;

    // 表单地理位置选择数据
    mapFormSelectedDatas:any;

    // tab（如生平、流传、修复等）选中id
    otherInfoId = '';

    // 表单，当前填充的数据索引值
    fillInstanceIndex = {
        oneIndex: '',
        twoIndex: ''
    }

    // 表单push数据，做为副本
    attributeChNameForm: any;

    // 表单验证失败的字段名数组
    errorList = [];

    // 表单月数据
    monthArr = new Array(12).fill('').map((item, index) => index + 1);

    // 表单日数据
    dayArr = new Array(31).fill('').map((item, index) => index + 1);

    // 实体详情数据
    instanceDetailData: any = {
        instanceId: ''
    };

    bailiwickList = [];  // 所属辖区字典项

    // tab菜单切换选中的菜单名称
    tabId = '001';

    // 单条来源信息修改
    editSourceDatas = {
        firstIndex: 0,
        secondIndex: 0
    }
    
    // 表单控件类型
    formControlTypes = KmsEnum.FORM_CONTROL_TYPES;
    // 用户角色
    userRole = '';
    // 图像上传组件id;
    imgComponentId = '';

    // 接收父组件的数据：实体添加入口
    @Input() addPath:any;

    // 接收父组件的数据：素材内容
    @Input() materialContent: any;

    // 向父组件传值
    @Output() componentState = new EventEmitter();

    // 向父组件传值最小化
    @Output() smallModal = new EventEmitter();

    @ViewChild('f') ngForm: NgForm; 

    // 待删除的属性三元组的关系边uuid
    deleteUuids:any = [];

    constructor(
        private http: SwHttpClientService,
        private router: Router,
        private User: GetUserModelService, //获取用户服务
        private tabServe: SwTabService,
        private routeInfo: ActivatedRoute,
        private kmsService: KmsService,
        private dicService: DictionaryService,
        private instanceModuleService: InstanceModuleService,
        private message: SwMassageBoxService,
        private create: SwCreateModalComponentService,
        private jwt: SwJwtService,
        private swMaskService: SwMaskService
    ) { }

    ngOnInit() {

        // 获取用户角色
        this.userRole = this.jwt.getToken('userRole');
        // 生成图像上传组件id（避免一个页面中出现多个上传组件时的冲突问题）
        this.imgComponentId = 'img'+this.instanceModuleService.uuid2();
        // 页面默认不滚动
        $('.add-from').scrollTop(0);
        // 获取行政区划字典项
        this.getDictionaryList();
        // 通过知识库标识拼接文件策略
        let kgDbInfo = JSON.parse(this.jwt.getToken('kgDbInfo'));
        let kgCode = kgDbInfo && kgDbInfo.englishCode ? kgDbInfo.englishCode : '';
        this.autoCode = kgCode ? KmsEnum.KMS_INSTANCE_RESOURCE + '_' + (kgCode.toUpperCase()) : '';
        // 获取路由参数
        this.routeInfo.queryParams.subscribe((data: Params) => {
            // 实体管理页面跳转
            if(this.addPath != 'quickMenu'){
                const params = JSON.parse(data['selectData']);
                // 判断当前是否为编辑、质检操作
                if (params['addOrUpdate'] != 'Add') {
                    // 根据实体id获取实体详情，加载表单
                    this.initEditFunction(params);
                    // 查询概念树数据
                    this.getOnlogyTreePageList();
                    // 判断是否存在序列号，不存在则重新获取
                    if (params.serialNumber) {
                        this.params.serialNumber = params.serialNumber;
                    } else {
                        // 通过标识自动生成序列号数据
                        this.getInstanceMaxSerialNumber();
                    }
                } else if (params['addOrUpdate'] == 'Add') {
                    this.params.addOrUpdate = 'Add';
                    this.params.conceptId = params.conceptId;
                    // 查询概念树数据（新增状态下会自动获取第一个概念叶子节点，并加载表单）
                    this.getOnlogyTreePageList();
                    // 生成instanceId
                    this.instanceDetailData.instanceId = this.instanceModuleService.uuid2();
                    // 通过标识自动生成序列号数据
                    this.getInstanceMaxSerialNumber();
                }
            }
        });
    }

    ngOnChanges() {
        // 快捷菜单
        if (this.materialContent.upOrAdd === 'Add') {
            this.params.addOrUpdate = 'Add';
            // 生成instanceId
            this.instanceDetailData.instanceId = this.instanceModuleService.uuid2();
            // 通过标识自动生成序列号数据
            this.getInstanceMaxSerialNumber();
            // 查询概念树数据
            this.getOnlogyTreePageList();
        }
        if (this.materialContent.upOrAdd === 'Edit') {
            let params = {
                instanceId: this.materialContent.instanceData.instanceId,
                addOrUpdate: this.materialContent.upOrAdd,
                conceptId: this.materialContent.instanceData.conceptId,
                conceptName: this.materialContent.instanceData.conceptName
            }
            this.params.serialNumber = this.materialContent.instanceData.serialNumber;
            // 查询概念树数据
            this.getOnlogyTreePageList();
            // 根据实体id获取实体详情，加载表单
            this.initEditFunction(params);
        }
    }

    // 获取行政区划字典项
    getDictionaryList() {
        let Params = { "param": { pageSize: 0 } };
        this.kmsService.getAdministrativeDivisionList(Params).subscribe(res => {
          if (res.code == 200) {
            this.bailiwickList = res["data"]["records"];
            let rootRegion = this.bailiwickList.find(item => item.regionName == '全国');
            let regions = [];
            if(rootRegion){
                let provinces = this.bailiwickList.filter(item => item.parentId == rootRegion.regionId);
                // 处理省级数据
                provinces.forEach(element => {
                  element.id = element.regionCode;
                  element.pid = rootRegion.regionCode;
                  regions.push(element);
                  let jx = [];
                  // 处理市级数据
                  let cities = this.bailiwickList.filter(item => item.parentId == element.regionId);
                  cities.forEach(child => {
                    child.id = child.regionCode;
                    child.pid = element.regionCode;
                    regions.push(child);
                    if(element.regionName == '江西省'){
                        jx.push({
                            regionName: child.regionName,
                            regionCode: child.regionCode
                        });
                    }
                    // 处理区级数据
                    let areas = this.bailiwickList.filter(item => item.parentId == child.regionId);
                    areas.forEach(el => {
                        el.id = el.regionCode;
                        el.pid = child.regionCode;
                        regions.push(el);
                    })
                  })
                  if(jx.length>0){
                    console.log(jx)
                  }
                });
            }
            this.bailiwickList = JSON.parse(JSON.stringify(regions));
          }
        });
    }

    // 清除页面数据
    clearData(){
        this.params.instanceId = '';
        this.params.instanceName = '';
        this.params.conceptId = '';
        this.params.conceptName = '';
        this.selectedTags = [];
    }

    // 初始化页面编辑方法
    initEditFunction(params) {
        this.params.instanceId = params.instanceId;
        this.params.addOrUpdate = params.addOrUpdate;
        this.params.conceptId = params.conceptId;
        this.params.conceptName = params.conceptName;
        this.getInstanceById(params.instanceId);
    }

    // 滚动条滚动更改操作菜单显示位置
    listenScroll(event) {
        if (event.srcElement.scrollTop > 150) {
            $('.content-tab').addClass('content-fixed');
        } else {
            $('.content-tab').removeClass('content-fixed');
        }
    }

    // 通过标识自动生成序列号数据
    getInstanceMaxSerialNumber() {
        this.kmsService.getInstanceMaxSerialNumber().subscribe(
            result => {
                if (result.code == '200') {
                    this.params.serialNumber = result.data;
                }
            }
        );
    }

    // 根据概念id查询属性字段配置表单信息
    getInstanceFormData(id) {
        this.isLoading = true;
        this.kmsService.getAttributeForForm(id).subscribe(
            result => {
                this.isLoading = false;
                if (result.code == '200') {
                    // 渲染基本信息表格
                    // 获取著录信息配置
                    let commonAttributes = result.data.commonAttributes.sort(function(a,b){
                        return a.sortNum - b.sortNum
                    });
                    let datas = [];
                    commonAttributes.forEach(el => {
                        datas.push([el]);
                    });

                    // 获取复合属性信息配置
                    let datasItem = result.data.compositeAttributes;
                    this.compositeAttributes = [];
                    let tabDatas = [
                        {attributeName: '著录信息', attributeId: '001', id: 'descriptInfo'}
                    ];
                    if (datasItem && datasItem.length > 0) {
                        datasItem.forEach(item => {
                            item.attributeName = $.trim(item.attributeName) + '信息'
                            item.id = 'otherInfo';
                            tabDatas.push(item);
                            this.compositeAttributes.push(item);
                        })
                    }
                    if(this.addPath != 'quickMenu'){
                        tabDatas.push(
                            {attributeName: '关系配置', attributeId: '002', id: 'relationInfo'},
                            {attributeName: '关联资源', attributeId: '003', id: 'resourceInfo'}
                        );
                    }
                    this.multipleAttribute = tabDatas;
                    // 实体新增时
                    for (let i = 0; i < datas.length; i++) {
                        let attrDatas = datas[i];
                        for (let j = 0; j < attrDatas.length; j++) {
                            attrDatas[j].id = -1;
                            attrDatas[j].attributeChName = '';
                            attrDatas[j].triplesId = this.instanceModuleService.uuid2();
                            attrDatas[j].attributeChNameOther = '';
                            attrDatas[j].geo = '';
                            attrDatas[j].sourceList = [];
                            // 当输入类型为下拉框时，获取下拉选项数组
                            if (attrDatas[j].fieldType == this.formControlTypes.dropBox && attrDatas[j].dictionryCode) {
                                attrDatas[j]['options'] = this.dicService.getDictionaryValueOrName(
                                    attrDatas[j].dictionryCode
                                );
                            }
                            // 当输入类型为树形下拉框时，获取下拉选项数组
                            if (attrDatas[j].fieldType == this.formControlTypes.treeSelect && attrDatas[j].dictionryCode) {
                                attrDatas[j]['options'] = this.dicService.getDictionaryTree(attrDatas[j].dictionryCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
                                let options = JSON.parse(JSON.stringify(attrDatas[j]['options']));
                                attrDatas[j]['options'].forEach(element => {
                                    let item = options.filter(el => el.id == element['pid']);
                                    element['pid'] = item.length>0 ? item[0].value : '0';
                                    element['parentId'] = element['pid'];
                                    element['id'] = element['value'];
                                });
                            }
                            // 当输入类型为单选
                            if (attrDatas[j].fieldType == this.formControlTypes.radio) {
                                attrDatas[j]['options'] = attrDatas[j]['dictionryCode'].split('、');
                                if(attrDatas[j]['options'].length == 0){
                                    attrDatas[j]['options'] = ['','']
                                }
                                if(attrDatas[j]['options'].length == 1){
                                    attrDatas[j]['options'].push('')
                                }
                            }
                            // // 当输入类型为长度、宽度
                            // if (attrDatas[j].fieldType == this.formControlTypes.size) {
                            //     attrDatas[j]['options'] = this.dicService.getDictionaryValueOrName(KmsEnum.KGS_UNIT_OPTION);
                            // }
                            // // 当输入类型为三维数据
                            // if (attrDatas[j].fieldType == this.formControlTypes.threeDimension) {
                            //     attrDatas[j]['options'] = this.dicService.getDictionaryValueOrName(KmsEnum.KGS_THREEDIMENSION_TYPE_OPTION);
                            // }
                        }
                    }
                    // 保存属性结构数据用于筛选删除
                    this.attributeChNameForm = JSON.parse(JSON.stringify(datas));
                    // 实体编辑或质检时
                    if (this.params.addOrUpdate != 'Add') {
                        datas = this.editFormData(datas);
                    }
                    // 保存属性结构数据
                    this.baseInfoConfig = datas;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 查询概念树数据
    getOnlogyTreePageList() {
        this.kmsService.getConceptTreeData({}).subscribe(
            data => {
                if (data.code == 200) {
                    if (!data.data) {
                        this.ontologyTreeDatas = [];
                    }
                    this.ontologyTreeDatas = data.data;
                    this.readonlySelfIds = ['0'];
                    // 新增状态下会自动获取第一个概念叶子节点，并加载表单
                    if (this.params.addOrUpdate === 'Add') {
                        // 获取不可选择的概念树节点
                        this.ontologyTreeDatas.forEach(item => {
                            if(this.ontologyTreeDatas.filter(item1 => item1.pid == item.id).length > 0){
                                this.readonlySelfIds.push(item.id);
                            }
                        })
                        // 获取默认选中的节点
                        let firstNode;
                        // 未带入默认概念id时
                        if (!this.params.conceptId) {
                            // 先找到概念树下面展示的第一个节点
                            firstNode = this.ontologyTreeDatas.filter(item => item.pid == 'root')[0];
                        }
                        // 有带入默认概念id时
                        else{
                            firstNode = this.ontologyTreeDatas.filter(item => item.id == this.params.conceptId)[0];
                        }
                        // 先判断该节点是否为叶子节点，是，设置选中；否，找到该节点下的第一个叶子节点并设置选中
                        if(this.readonlySelfIds.filter(el => el == firstNode.id).length == 0){
                            this.params.conceptId = firstNode.id;
                            this.activeTreeCode = firstNode.code;
                            this.mapping = firstNode.mapping;
                            this.params.conceptName = firstNode.name;
                        }
                        else{
                            let firstLeafNode = this.getFirstLeafNode(firstNode.id);
                            this.params.conceptId = firstLeafNode.id;
                            this.activeTreeCode = firstLeafNode.code;
                            this.mapping = firstLeafNode.mapping;
                            this.params.conceptName = firstLeafNode.name;
                        }
                        // 根据选中概念id查询属性字段配置表单信息
                        this.getInstanceFormData(this.params.conceptId);
                    }
                }
            }
        );
    }

    // 查找某个节点下的第一个叶子节点
    getFirstLeafNode(parentId){
        let childs = this.ontologyTreeDatas.filter(item => item.pid == parentId);
        let index = -1;
        for(let i=0;i<childs.length;i++){
            if(this.readonlySelfIds.filter(el => el == childs[i].id).length == 0){
                index = i;
                break;
            }
        }
        if(index >= 0){
            return childs[index] 
        }else{
            return this.getFirstLeafNode(childs[0].id)
        }
    }

    // 实体编辑处理表单结构
    // datas：当前选中概念的属性配置
    editFormData(datas) {
        // 清空待删除的边数据
        this.deleteUuids = [];
        // 清空监听到发生变化的属性值数据
        this.tripleFormDatas = [];
        // 当前实体详细包含的三元组数据内容
        let triples = this.instanceDetailData.attrs;
        datas.forEach((item, index) => {
            let itemDatas = item[0];
            let sourceObj:any = {};
            itemDatas = JSON.parse(JSON.stringify(itemDatas));
            if (triples && triples.length > 0) {
                for (let i = 0; i < triples.length; i++) {
                    // 判断属性三元组中的属性id 与 当前属性的属性id是否相同
                    // 若是当前属性，则需要把属性值、数据来源等信息塞入到表单结构中
                    if (itemDatas.attributeId == triples[i].relationshipId) {
                        // uuid不存在，表示当前字段编辑时有初始数据，需删除第一条默认数据
                        if (itemDatas.id == -1) {
                            datas[index].splice(0, 1);
                        }
                        // 获取属性值节点id
                        itemDatas.id = triples[i].id;

                        // 下拉框类型
                        if (itemDatas.fieldType === this.formControlTypes.dropBox && itemDatas.dictionryCode && triples[i].dictCode) {
                            itemDatas.attributeChName = triples[i].dictCode;
                        } 

                        // 树形下拉框类型
                        if (itemDatas.fieldType === this.formControlTypes.treeSelect && itemDatas.dictionryCode && triples[i].dictCode) {
                            itemDatas.attributeChName = triples[i].dictCode;
                        } 

                        // 行政区划
                        if (itemDatas.fieldType === this.formControlTypes.administrativeDivision) {
                            itemDatas.attributeChName = triples[i].dictCode;
                        } 
                        
                        // 短文本、单选、文本域、富文本框
                        if(itemDatas.fieldType === this.formControlTypes.input || itemDatas.fieldType === this.formControlTypes.nowDate || itemDatas.fieldType === this.formControlTypes.radio || itemDatas.fieldType === this.formControlTypes.textarea || itemDatas.fieldType === this.formControlTypes.richTextBox){
                            itemDatas.attributeChName = triples[i].attributeValue;
                        }

                        // 地理位置  带备注信息和不带备注信息
                        if (itemDatas.fieldType === this.formControlTypes.geoRemark || itemDatas.fieldType === this.formControlTypes.geo) {
                            itemDatas.attributeChName = triples[i].attributeValue;
                            itemDatas.attributeChNameOther = triples[i].remark == 'null' ? '' : triples[i].remark;
                            itemDatas.geo = triples[i].dictCode;
                        }
                        // 时间日期  带备注信息和不带备注
                        if (itemDatas.fieldType === this.formControlTypes.dateRemark || itemDatas.fieldType === this.formControlTypes.date) {
                            itemDatas.attributeChNameOther = triples[i].attributeValue;
                            itemDatas.attributeChName = triples[i].dictCode;
                        }
                        // // 长度、宽度、长宽单位
                        // if (itemDatas.fieldType === this.formControlTypes.size) {
                        //     itemDatas.attributeChName = triples[i].attributeValue;
                        //     itemDatas.attributeChNameOther = triples[i].dictCode;
                        // }
                        // // 三维数据
                        // if (itemDatas.fieldType === this.formControlTypes.threeDimension) {
                        //     itemDatas.attributeChName = triples[i].attributeValue;
                        //     itemDatas.attributeChNameOther = triples[i].dictCode;
                        // }
                        itemDatas.triplesId = this.instanceModuleService.uuid2();
                        
                        const sourceItem = {
                            "uuid": triples[i].uuid,
                            "materialId":triples[i].materialId,
                            "sourceText":triples[i].sourceText,
                            "sourceMaterial":triples[i].sourceMaterial,
                            "pageNum":triples[i].pageNum,
                            "relPageNum":triples[i].relPageNum,
                            "datasource":triples[i].datasource
                        }
                        if(sourceObj[itemDatas.id]){
                            sourceObj[itemDatas.id].sourceList.push(sourceItem);
                        }else{
                            sourceObj[itemDatas.id] = JSON.parse(JSON.stringify(itemDatas));
                            sourceObj[itemDatas.id]['sourceList'] = [sourceItem]
                        }
                    }
                }
            }
            let keys = Object.keys(sourceObj);
            if(keys.length>0){
                datas[index] = [];
                for(let i=0;i<keys.length;i++){
                   datas[index].push(sourceObj[keys[i]])
                }
            }
        });
        return JSON.parse(JSON.stringify(datas));;
    }

    // 概念下拉选择事件
    handleConceptChange(event) {
        this.params.instanceName = '';
        this.params.instanceId = '';
        this.tripleFormDatas = [];
        const item = this.ontologyTreeDatas.filter(item => item.id == event.id);
        this.params.conceptName = event.text;
        if (item.length > 0) {
            this.activeTreeCode = item[0].code;
            this.mapping = item[0].mapping;
        }
        // 根据概念id查询属性字段配置表单信息
        this.getInstanceFormData(event.id);
    }

    // 查询实体列表信息数据
    getInstanceList() {
        let Params = {
            current: 1,
            size: 30,
            instanceName: this.params.instanceName,
            conceptId: this.params.conceptId
        };
        this.kmsService.getInstanceQueryList(Params).subscribe(
            result => {
                if (result.code == 200) {
                    this.instanceDatasList = result.data.records;
                } else {
                    this.message.waring(result.msg);
                }
            }
        );
    }

    // 根据实体ID查询实体详细信息 type为真时，表示是从通过实体名称输入框搜索的下拉列表中选中的某个实体
    getInstanceById(id, type?) {
        this.kmsService.getInstanceById(id).subscribe(
            result => {
                if (result.code == 200) {
                    let datas = result.data;
                    this.instanceDetailData = datas;
                    if (datas.tags) {
                        this.selectedTags = datas.tags;
                    } else {
                        this.selectedTags = [];
                    }
                    this.params.instanceName = datas.instanceName;
                    this.activeTreeCode = datas.conceptCode;
                    this.mapping = datas.mapping;
                    // 从通过实体名称输入框搜索的下拉列表中选中的某个实体
                    if (type) {
                        this.baseInfoConfig = this.editFormData(this.attributeChNameForm);
                    } 
                    // 通过路由跳转进入某个实体的编辑页面
                    else {
                        // 根据概念id查询属性字段配置表单信息
                        this.getInstanceFormData(this.params.conceptId);
                    }
                }
            }
        )
    }

    // 已选择标签发生变化时重新获取
    tagsChange(event){
        this.selectedTags = event;
    }

    // 实体下拉搜索列表点击事件
    handleSearchInstanceClick(data) {
        this.instanceDatasList = [];
        this.params.addOrUpdate = 'Edit';
        this.params.instanceName = data.instanceName;
        this.params.instanceId = data.instanceId;
        this.params.conceptId = data.conceptId;
        this.params.conceptName = data.conceptName;
        this.getInstanceById(this.params.instanceId, 1);
    }

    // 实体输入框内容发生变化时方法
    handleInstanceChange(event) {
        // if (this.addPath !== 'quickMenu') {
        //     return;
        // }      
        // // 阻止点击enter键时触发自动补全功能
        // if (event.keyCode == '13') {
        //     let data = this.instanceDatasList.filter(item => item.instanceName == this.params.instanceName)[0];
        //     if (data) {
        //         this.handleSearchInstanceClick(data);
        //     }
        //     return;
        // }
        // // 向上选中自动补全列表项
        // if (event.keyCode == '38') {
        //     if (this.instanceDatasList.length > 0) {
        //         if (this.activeInstanceIndex > 0) {
        //             this.activeInstanceIndex--;
        //             const scrollTop = $('.instance-list').scrollTop();
        //             $('.instance-list').animate({ scrollTop: scrollTop - 30 }, 100);
        //             this.params.instanceName = this.instanceDatasList[this.activeInstanceIndex].instanceName;
        //         }
        //     }
        //     return;
        // }
        // // 向下选中自动补全列表项
        // if (event.keyCode == '40') {
        //     if (this.instanceDatasList.length > 0) {
        //         if (this.activeInstanceIndex < this.instanceDatasList.length - 1) {
        //             this.activeInstanceIndex++;
        //             if (this.activeInstanceIndex > 0) {
        //                 const scrollTop = $('.instance-list').scrollTop();
        //                 $('.instance-list').animate({ scrollTop: scrollTop + 30 }, 100);
        //             }
        //             this.params.instanceName = this.instanceDatasList[this.activeInstanceIndex].instanceName;;
        //         }
        //     }
        //     return;
        // }
        // // 查询自动补全列表
        // this.handleFocusFun();
    }

    // 实体输入框获取焦点时方法
    handleFocusFun() {
        // if (this.addPath === 'quickMenu') {
        //     this.getInstanceList();
        // } 
    }

    // 实体输入框失去焦点时方法
    handleBlurFun() {
        // if (this.addPath === 'quickMenu') {
        //     setTimeout(() => {
        //         this.instanceDatasList = [];
        //         this.activeInstanceIndex = -1;
        //     }, 200);
        // } 
    }

    // tab菜单切换点击方法
    handleTabClick(id) {
        if (id === '001') {
            this.isTopFormTabEdit = false;
        } else {
            if (!this.params.instanceId) {
                this.message.info(`没有保存实体信息！不能添加其他内容`);
                return;
            }
            this.isTopFormTabEdit = true;
        }
        $('.add-from').scrollTop(0);
        this.tabId = id;
    }

    // 选中素材内容，填充到输入框中
    handleFillInstanceName() {
        let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
        if(data){
            this.params.instanceName = data.sourceText;
        }
        this.jwt.setToKen('materialTextSelect','');
    }

    // 选中素材内容，填充到输入框中
    handleFillClick(i, m) {
        let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
        let fieldType = this.baseInfoConfig[i][m].fieldType;
        if(data){
            // 短文本、文本域、富文本框
            if(fieldType === this.formControlTypes.input || fieldType === this.formControlTypes.textarea || fieldType === this.formControlTypes.richTextBox){
                this.baseInfoConfig[i][m].attributeChName = data.sourceText;
            }

            // 地理位置  带备注信息和不带备注信息
            if (fieldType === this.formControlTypes.geoRemark || fieldType === this.formControlTypes.geo) {
                this.baseInfoConfig[i][m].attributeChNameOther = data.sourceText;
            }
            // 时间日期  带备注信息和不带备注
            if (fieldType === this.formControlTypes.dateRemark || fieldType === this.formControlTypes.date) {
                this.baseInfoConfig[i][m].attributeChNameOther = data.sourceText;
            }
            // 2.将该属性值添加到已发生变化的表单中
            this.handleFormChange(this.baseInfoConfig[i][m]);
        }
        this.jwt.setToKen('materialTextSelect','');
    }

    // 表单新增字段属性和属性来源内容
    handleAddFormClick(index) {
        let datas = JSON.parse(JSON.stringify(this.attributeChNameForm[index][0]));
        datas.id = -1;      // 属性值节点id
        datas.attributeChName = '';    // 属性值
        datas.attributeChNameOther = '';  // 属性值备注
        datas.geo = '';    // 地理位置类字段的坐标信息
        datas.triplesId = this.instanceModuleService.uuid2();  // 属性值唯一标识（用于监听属性值发生变化时）
        datas.sourceList = [];  // 数据来源
        this.baseInfoConfig[index].push(datas);
    }


    // 根据当前时间生成唯一ID值
    getTimeReturnId() {
        // 得到时间的13位毫秒数
        return new Date().getTime();
    }

    // 表单删除字段属性和属性来源内容
    // oneIndex: 一级索引（定位到哪个字段）
    // twoIndex: 二级索引（定位到某个字段的第几条数据）
    handleDelFormClick(oneIndex, twoIndex) {

        /*
            oneIndex： 当前字段在整个表单的索引值
            twoIndex： 当前字段在特殊表单的索引值
        */
        // 该字段的所有数据
        let datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex]));
        
        // 1.如果之前加入到待保存信息（tripleFormDatas）中的属性值被删除，则需要更新tripleFormDatas对象
        this.tripleFormDatas.forEach((item, index) => {
            if (item.triplesId == datas[twoIndex].triplesId) {
                this.tripleFormDatas.splice(index,1);
                return;
            }
        })

        // 2.获取该字段的当前属性值的所有边的uuid，加入到待删除字段
        let sourceList = datas[twoIndex].sourceList;
        // 判断三元组数据ID是否存在
        if (sourceList.length>0) {
            sourceList.forEach(element => {
                if(element.uuid){
                    this.deleteUuids.push(element.uuid);
                }
            });
        } 

        // 3.处理页面显示的表单结构
        if (datas.length > 1) {
            datas.splice(twoIndex, 1);
        } else {
            datas[0].id = -1;
            datas[0].attributeChName = '';
            datas[0].attributeChNameOther = '';
            datas[0].geo = '';
            datas[0].sourceList = [];
        }
        this.baseInfoConfig[oneIndex] = datas;
    }

    // 表单内容，日期年月日赋值
    getYearOrMonthOrDay(type, keyName, m, item) {
        let index = String(m);
        let val = $('#' + item + keyName + index).val();
        if (val) {
            let str = this.instanceModuleService.getYearOrMonthOrDay(type, val);
            return str;
        }
    }

    // 表单内容，监听时间输入框的变化，判断是否合法
    getDateStr(keyName, oneIndex, twoIndex, type) {
        /*
            keyName: 当前字段信息的英文标识值
            oneIndex: 当前字段在整个表单结构的索引值
            twoIndex: 当前字段在表单的索引值
            type: 当前字段属于（special：特殊表单字段，note：带备注信息字段，no：不带备注信息字段）
        */

        let index = String(twoIndex);
        let parent = $('#' + type + keyName + index).parent();
        const yearValue = parent.find('.year').val();
        const monthValue = parent.find('.month').val();
        const dayValue = parent.find('.day').val();

        // 返回时间 年/月/日
        let res = this.instanceModuleService.validateTime(yearValue, monthValue, dayValue);

        // 将 年/月/日 赋值给隐藏的输入框
        $('#' + type + keyName + index).val(res.timeStr);


        // 判断 年/月/日 表单验证是否输入合法
        if (!res.isValid) {
            if (this.errorList.indexOf(keyName) < 0) {
                this.errorList.push(keyName);
                parent.parent().find('.tip-error').removeClass('hidden');
                parent.find('.year,.month,.day').addClass('input-error');
            }
        } else {
            const index = this.errorList.indexOf(keyName);
            if (index >= 0) {
                this.errorList.splice(index, 1);
                parent.parent().find('.tip-error').addClass('hidden');
                parent.find('.year,.month,.day').removeClass('input-error');
            }
        }

        let datas;
        if (type === 'note'){
            // 转换数据，得到当前字段在特殊表单属于哪条数据
            datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex][twoIndex]));
            // 将隐藏输入框的 年/月/日 赋值给表单数组
            datas.attributeChName = $('#' + type + keyName + index).val();
            this.baseInfoConfig[oneIndex][twoIndex] = datas;
        } else if (type === 'no') {
            // 转换数据，得到当前字段在特殊表单属于哪条数据
            datas = JSON.parse(JSON.stringify(this.baseInfoConfig[oneIndex][twoIndex]));
            // 将隐藏输入框的 年/月/日 赋值给表单数组
            datas.attributeChName = $('#' + type + keyName + index).val();
            this.baseInfoConfig[oneIndex][twoIndex] = datas;
            let this_ = this;
            setTimeout(function () {
                this_.handleFormChange(this_.baseInfoConfig[oneIndex][twoIndex])
            }, 500)
        }

        // 获取年号数据，存储到时间备注里
        if (yearValue && type !== 'no') {
            if (yearValue > 1949) {
                datas.attributeChNameOther = `${yearValue}年`;
                this.baseInfoConfig[oneIndex][twoIndex] = datas;
            } else {
                this.kmsService.getInstanceTimeNoteByYear(yearValue).subscribe(
                    data => {
                        if (data.code == '200') {
                            const res = data.data;
                            datas.attributeChNameOther = res;
                            this.baseInfoConfig[oneIndex][twoIndex] = datas;
                        } else {
                            console.log(data.msg);
                        }
                    }
                );
            }
            let this_ = this;
            if (type === 'note') {
                setTimeout(function () {
                    this_.handleFormChange(this_.baseInfoConfig[oneIndex][twoIndex])
                }, 500)
            }
        }
    }

    // 表单内容，展示选择地理位置弹框
    // index: 一级索引定位到哪个字段
    // items: 该字段的所有数据
    showSelectMapModal(index, items) {
        this.mapFormSelectedIndex = index;
        this.create.createModal(KmgMapComponent, items, this.mapFunction.bind(this));
    }

    // 地图服务回调函数
    mapFunction(event) {
        let pointData = JSON.parse(JSON.stringify(this.baseInfoConfig[this.mapFormSelectedIndex][0]));
        // 获取编辑完成的地理位置信息并填入到表单中
        // 若存在选中的地理位置,则将数据回填到表单中
        if (event.data && event.data.length>0) {
            this.baseInfoConfig[this.mapFormSelectedIndex] = event.data;
        }
        // 若不存在选中的地理位置，则清空该字段值,
        else{
            pointData['geo'] = '';
            pointData['attributeChName'] = '';
            pointData['attributeChNameOther'] = '';
            pointData['sourceList'] = [];
            this.baseInfoConfig[this.mapFormSelectedIndex] = [pointData];
        }

        // 获取待删除的关系边uuid
        if(event.deleteIds){
            this.deleteUuids = this.deleteUuids.concat(event.deleteIds);
        }

        // 清除之前待保存信息的该属性
        let datas = [];
        if(this.tripleFormDatas.length>0){
            for(let i=0;i<this.tripleFormDatas.length;i++){
                if(this.tripleFormDatas[i].englishCode !== pointData.englishCode){
                    datas.push(this.tripleFormDatas[i]);
                }
            }
        }
        // 判断当前该属性是否有值，有，则添加到待保存对象中
        if (event.data && event.data.length>0){
            this.tripleFormDatas = datas.concat(event.data);
        }
    }

    // 批量添加来源方法
    handleAddSourceClick() {
    }

    // 查看来源方法
    // item:选中字段的第secondIndex条数据
    // firstIndex: 一级索引（定位到哪个字段）
    // secondIndex: 二级索引（定位到某个字段的第几条数据）
    handleSourceEditClick(item, firstIndex, secondIndex) {
        this.editSourceDatas = {
            firstIndex: firstIndex,
            secondIndex: secondIndex
        }
        const data = {
            state: 'edit',
            sourceList: item.sourceList
        }
        this.create.createModal(EditDatasourceComponent, data, this.editDatasourceFunction.bind(this));
    }

    // 编辑属性来源回调函数
    editDatasourceFunction(event){
        //  1.处理页面显示的表单结构
        const oneIndex = this.editSourceDatas.firstIndex;
        const twoIndex = this.editSourceDatas.secondIndex;
        // 获取编辑完成的来源信息并填入到表单中
        this.baseInfoConfig[oneIndex][twoIndex].sourceList = event.data;

        // 2.将该属性值添加到已发生变化的表单中
        this.handleFormChange(this.baseInfoConfig[oneIndex][twoIndex]);

        // 3.接收删除的来源数据id,加入到待删除边id对象
        this.deleteUuids = this.deleteUuids.concat(event.deleteIds)
    }

    // 监听表单是否发生变化
    handleFormChange(event) {    
        if(this.tripleFormDatas.length > 0) {
            // 判断当前修改过的三元组是否已经加入过tripleFormDatas数组
            let status = true;
            this.tripleFormDatas.forEach((item, index) => {
                if (item.triplesId == event.triplesId) {
                    // 已修改过则替换为当前修改的值
                    this.tripleFormDatas[index] = event;
                    status = false;
                    return;
                }
            })
            // 没有修改过则需要添加到tripleFormDatas
            if (status) {
                this.tripleFormDatas.push(event);
            }
        } else {
            this.tripleFormDatas.push(event);
        }
    }

    // 保存按钮，表单内容保存
    // state: save:只保存；submitAndNext: 提审并查看下一条；publishAndNext：发布并查看下一条；
    // addToTab: true:添加到tab页; 
    onSubmit(state,addToTab?) {
        this.swMaskService.openMask("数据正在保存,请稍等...");
        // 拼接著录信息三元组数组
        let attributes = [];
        let geoSaveList = [];
        let noSourceAttr = [];
        let instanceId = this.params.instanceId ? this.params.instanceId : this.instanceDetailData.instanceId;
        for (let i = 0; i < this.tripleFormDatas.length; i++) {
            let tripleItem = this.tripleFormDatas[i];
            // 属性值为空时不进行保存操作
            if(!tripleItem.attributeChName && !tripleItem.attributeChNameOther){
                continue;
            }
            let sourceList = tripleItem.sourceList;
            // 地理位置带备注和不带备注类型
            if (tripleItem.fieldType === this.formControlTypes.geoRemark || tripleItem.fieldType === this.formControlTypes.geo) {
                if(sourceList.length>0){
                    // 每个属性值可能有多个来源,需要遍历来源信息将每个来源的属性值处理成一条单独的数据
                    sourceList.forEach(source => {
                        // 地理位置信息
                        geoSaveList.push({
                            placeId: source.uuid,
                            materialId: source.materialId,
                            sourceText: source.sourceText,
                            sourceMaterial: source.sourceMaterial,
                            pageNum: source.pageNum,
                            relPageNum: source.relPageNum,
                            datasource: source.datasource,
                            geo: (tripleItem.geo && tripleItem.geo != 'none') ? tripleItem.geo : '',
                            hgisName: tripleItem.attributeChName,
                            placeName: tripleItem.attributeChName,
                            placeNote: tripleItem.attributeChNameOther,
                            relationshipId: tripleItem.attributeId,
                            englishCode: tripleItem.englishCode,
                            relationshipName: tripleItem.attributeName,
                            sortNum: tripleItem.sortNum,
                            isShow: tripleItem.isShow
                        })
                    });
                }else{
                    // 记录未录入来源的字段
                    if(noSourceAttr.filter(el => el == tripleItem.attributeName).length == 0){
                        noSourceAttr.push(tripleItem.attributeName);
                    }
                    if(!environment.isSourceRequired){
                        // 地理位置信息
                        geoSaveList.push({
                            placeId: '',
                            materialId: '',
                            sourceText: '',
                            sourceMaterial: '',
                            pageNum: 1,
                            relPageNum: 1,
                            datasource: '',
                            geo: (tripleItem.geo && tripleItem.geo != 'none') ? tripleItem.geo : '',
                            hgisName: tripleItem.attributeChName,
                            placeName: tripleItem.attributeChName,
                            placeNote: tripleItem.attributeChNameOther,
                            relationshipId: tripleItem.attributeId,
                            englishCode: tripleItem.englishCode,
                            relationshipName: tripleItem.attributeName,
                            sortNum: tripleItem.sortNum,
                            isShow: tripleItem.isShow
                        });
                    }
                }
            } else {
                if(sourceList.length>0){
                    // 每个属性值可能有多个来源,需要遍历来源信息将每个来源的属性值处理成一条单独的数据
                    sourceList.forEach(source => {
                        let attributeValue = '', dictCode = '';
                        // 下拉框类型
                        if (tripleItem.fieldType === this.formControlTypes.dropBox && tripleItem.dictionryCode) {
                            attributeValue = this.dictionaryConversion(tripleItem.attributeChName, tripleItem.options);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 树形下拉框类型
                        if (tripleItem.fieldType === this.formControlTypes.treeSelect && tripleItem.dictionryCode) {
                            attributeValue = this.dictionaryConversion(tripleItem.attributeChName, tripleItem.options);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 行政区划
                        if (tripleItem.fieldType === this.formControlTypes.administrativeDivision) {
                            attributeValue = this.getBailiwick(tripleItem.attributeChName);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 短文本、单选、文本域、富文本框
                        if(tripleItem.fieldType === this.formControlTypes.input || tripleItem.fieldType === this.formControlTypes.nowDate || tripleItem.fieldType === this.formControlTypes.radio || tripleItem.fieldType === this.formControlTypes.textarea || tripleItem.fieldType === this.formControlTypes.richTextBox){
                            attributeValue = tripleItem.attributeChName;
                            dictCode = '';
                        }
                        // 时间日期  带备注信息
                        if (tripleItem.fieldType === this.formControlTypes.dateRemark) {
                            attributeValue = tripleItem.attributeChNameOther;
                            dictCode = tripleItem.attributeChName;
                        }
                        // 时间日期  不带备注信息
                        if (tripleItem.fieldType === this.formControlTypes.date) {
                            attributeValue = '';
                            dictCode = tripleItem.attributeChName;
                        }
                        // // 长度、宽度（带单位）
                        // if (tripleItem.fieldType === this.formControlTypes.size) {
                        //     attributeValue = tripleItem.attributeChName;
                        //     dictCode = tripleItem.attributeChNameOther;
                        // }
                        // // 三维数据
                        // if (tripleItem.fieldType === this.formControlTypes.threeDimension) {
                        //     attributeValue = tripleItem.attributeChName;
                        //     dictCode = tripleItem.attributeChNameOther;
                        // }
                        attributes.push({
                            uuid: source.uuid,
                            materialId: source.materialId,
                            sourceText: source.sourceText,
                            sourceMaterial: source.sourceMaterial,
                            pageNum: source.pageNum,
                            relPageNum: source.relPageNum,
                            datasource: source.datasource,
                            attributeValue: attributeValue,
                            dictCode: dictCode,
                            relationshipId: tripleItem.attributeId,
                            relationshipName: tripleItem.attributeName,
                            englishCode: tripleItem.englishCode,
                            sortNum: tripleItem.sortNum,
                            isShow: tripleItem.isShow
                        })
                    });
                }else{
                    // 记录未录入来源的字段
                    if(noSourceAttr.filter(el => el == tripleItem.attributeName).length == 0){
                        noSourceAttr.push(tripleItem.attributeName);
                    }
                    if(!environment.isSourceRequired){
                        let attributeValue = '', dictCode = '';
                        // 下拉框类型
                        if (tripleItem.fieldType === this.formControlTypes.dropBox && tripleItem.dictionryCode) {
                            attributeValue = this.dictionaryConversion(tripleItem.attributeChName, tripleItem.options);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 树形下拉框类型
                        if (tripleItem.fieldType === this.formControlTypes.treeSelect && tripleItem.dictionryCode) {
                            attributeValue = this.dictionaryConversion(tripleItem.attributeChName, tripleItem.options);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 行政区划
                        if (tripleItem.fieldType === this.formControlTypes.administrativeDivision) {
                            attributeValue = this.getBailiwick(tripleItem.attributeChName);
                            dictCode = tripleItem.attributeChName;
                        } 
                        // 短文本、单选、文本域、富文本框
                        if(tripleItem.fieldType === this.formControlTypes.input || tripleItem.fieldType === this.formControlTypes.nowDate || tripleItem.fieldType === this.formControlTypes.radio || tripleItem.fieldType === this.formControlTypes.textarea || tripleItem.fieldType === this.formControlTypes.richTextBox){
                            attributeValue = tripleItem.attributeChName;
                            dictCode = '';
                        }
                        // 时间日期  带备注信息
                        if (tripleItem.fieldType === this.formControlTypes.dateRemark) {
                            attributeValue = tripleItem.attributeChNameOther;
                            dictCode = tripleItem.attributeChName;
                        }
                        // 时间日期  不带备注信息
                        if (tripleItem.fieldType === this.formControlTypes.date) {
                            attributeValue = '';
                            dictCode = tripleItem.attributeChName;
                        }
                        // // 长度、宽度（带单位）
                        // if (tripleItem.fieldType === this.formControlTypes.size) {
                        //     attributeValue = tripleItem.attributeChName;
                        //     dictCode = tripleItem.attributeChNameOther;
                        // }
                        // // 三维数据
                        // if (tripleItem.fieldType === this.formControlTypes.threeDimension) {
                        //     attributeValue = tripleItem.attributeChName;
                        //     dictCode = tripleItem.attributeChNameOther;
                        // }
                        attributes.push({
                            uuid: '',
                            materialId: '',
                            sourceText: '',
                            sourceMaterial: '',
                            pageNum: 1,
                            relPageNum: 1,
                            datasource: '',
                            attributeValue: attributeValue,
                            dictCode: dictCode,
                            relationshipId: tripleItem.attributeId,
                            relationshipName: tripleItem.attributeName,
                            englishCode: tripleItem.englishCode,
                            sortNum: tripleItem.sortNum,
                            isShow: tripleItem.isShow
                        })
                    }
                }
            }
        }
        if(environment.isSourceRequired && noSourceAttr.length > 0){
            this.swMaskService.closeMask();
            let tip = noSourceAttr.join(',');
            this.message.danger(tip+'等属性未录入数据来源信息！');
            return;
        }

        // 拼接待处理的地理位置信息（mysql)
        let geoRels:any = {};
        let geos = [];
        for(let i=0;i<this.baseInfoConfig.length;i++){
            let configItem = this.baseInfoConfig[i];
            let childs = configItem.filter(el => el.fieldType === this.formControlTypes.geoRemark || el.fieldType === this.formControlTypes.geo);
            geos = geos.concat(childs);
        }
        if(geos.length>0){
            geos.forEach((child,index)=> {
                let geoItem = {
                    "category": 1,
                    "geo": !child.geo || child.geo == 'none' ? '' : child.geo,
                    "placeName": child.attributeChName,
                    "placeNote": child.attributeChNameOther,
                    "englishCode": child.englishCode,
                    "relationshipId": child.attributeId,
                    "relationshipName": child.attributeName,
                    "targetId": instanceId
                }
                if(geoRels[child.englishCode]){
                    if(geoItem.geo){
                        geoRels[child.englishCode]['places'].push(geoItem);
                    }
                }else{
                    geoRels[child.englishCode] = {
                        "relationshipId": child.attributeId,
                        "targetId": instanceId,
                        "places": []
                    };
                    if(geoItem.geo){
                        geoRels[child.englishCode]['places'].push(geoItem);
                    }
                }
            })
        }
        let geoRelsArr = [];
        let keys = Object.keys(geoRels);
        if(keys.length>0){
            for(let i=0;i<keys.length;i++){
                geoRelsArr.push(geoRels[keys[i]])
            }
        }

        // 拼接著录信息标签数据
        let tags = [];
        this.selectedTags.forEach(item => {
            tags.push({
                relationshipId: 'tag',
                relationshipName: '标签',
                sortNum: 0,
                tagId: item.tagId,
                tagName: item.tagName
            })
        })
        // 新增时默认为待指派状态
        let approvalStatus = 0;
        if(this.params.addOrUpdate == 'Edit' || this.params.addOrUpdate == 'Verify'){
            // 当前为仅保存 或 保存并查看下一条
            if(state == 'save'){
                approvalStatus = this.instanceDetailData.approvalStatus;
            }
            // 当前为提交质检并查看下一条
            if(state == 'submitAndNext'){
                approvalStatus = 2;
            }
            // 当前为发布并查看下一条
            if(state == 'publishAndNext'){
                approvalStatus = 5;
            }
        }
        let params = {
            currentUserRole: this.userRole == '知识编辑' ? 1 : 2,
            serialNumber: this.params.serialNumber,
            conceptId: this.params.conceptId,
            conceptCode: this.activeTreeCode,
            mapping: this.mapping,
            conceptName: this.params.conceptName,
            instanceId: instanceId,
            instanceName: this.params.instanceName,
            attributes: attributes,
            tags: tags,
            geoSaveList: geoSaveList,
            deleteAttrIds: this.deleteUuids,
            approvalStatus: approvalStatus
        }

        // 保存实体方法
        this.kmsService.saveInstanceUpdate(params).subscribe(
            result => {
                let datas = result.data;
                if (result.code == 200) {
                    this.swMaskService.closeMask();
                    if (this.params.addOrUpdate === 'Add') {
                        this.params.instanceId = datas.instanceId;
                        this.params.addOrUpdate = 'Edit';
                        this.params.conceptId = datas.conceptId;
                        this.params.conceptName = datas.conceptName;
                    }
                    this.instanceDetailData = datas;
                    // 实体编辑时
                    this.baseInfoConfig = this.editFormData(JSON.parse(JSON.stringify(this.attributeChNameForm)));
                    // 当前为添加到tab页操作时
                    if(addToTab){
                        let selectData = {
                            addOrUpdate: 'Edit',
                            instanceId: datas.instanceId,
                            conceptId: datas.conceptId,
                            conceptName: datas.conceptName,
                            serialNumber: datas.serialNumber,
                        };
                        this.router.navigate(
                            ['/kms/InstanceAdd'],
                            { queryParams: { Title: '编辑实体信息', selectData: JSON.stringify(selectData) } }
                        );
                    }
                    // 查看下一条待编辑实体
                    this.queryNext(state);

                    // 增量更新索引
                    this.updateIndex(datas.instanceId)
                } else {
                    this.swMaskService.closeMask();
                    this.message.waring(result.msg);
                }
            }
        )
        // 处理地理位置信息方法
        if(geoRelsArr.length>0){
            this.kmsService.updateCoordRelationship(geoRelsArr).subscribe(
                res => {
                    if(res.code != '200'){
                        this.message.waring('地理位置信息保存失败！');
                    }
                }
            )
        }
    }

    // 查看下一条待编辑实体
    queryNext(state){
        if(state == 'save'){
            this.message.success('数据保存成功！');
            return;
        }
        let params = {
            "approvalStatus": null,
            "editorUserId": "",
            "userType": 0
        };
        // 获取用户id
        const userId = this.User.getUser().userId;
        params.userType = (this.userRole == '超级管理员' || this.userRole =='知识库管理员') ? 1 : 2;
        params.approvalStatus = params.userType === 1 ? null : 1;
        params.editorUserId = params.userType === 1 ? '' : userId;
        this.kmsService.queryNextInstanceByUser(params).subscribe(
            res => {
                if(res.code == '200'){
                    if(res.data){
                        this.message.success('数据保存成功！');
                        this.refreshPage(res.data,'Edit');
                    }else{
                        this.message.info('所有待编辑实体均已提交质检！');
                        this.handleBackClick();
                    }
                }
            }
        )
    }

    // 根据下一条待编辑实体渲染页面
    refreshPage(data,operationState){
        let selectData = {
            addOrUpdate: operationState,
            instanceId: data.instanceId,
            conceptId: data.conceptId,
            conceptName: data.conceptName,
            serialNumber: data.serialNumber,
        };
        let title = operationState == '编辑实体信息' ? '' : '审核实体信息';
        this.router.navigate(
            ['/kms/InstanceAdd'],
            { queryParams: { Title: title, selectData: JSON.stringify(selectData) } }
        );
    }

    // 根据行政区划code获取名称 
    getBailiwick(val) {
        if (this.bailiwickList.length > 0) {
          let region = this.bailiwickList.find(ele => ele.id == val);
          let parent = this.bailiwickList.find(ele => ele.id == region.pid);
          if(parent){
            return  parent.text+','+region.text;
          }else{
            return region.text;
          }
        }
    }

    // 增量更新索引
    updateIndex(instanceId){
        this.kmsService.updateIndexByInstanceId(instanceId).subscribe(
            data => {
                if(data.code != '200'){
                    console.log('索引更新失败!');
                }
            }
        )
    }

    // 字典值转换为中文字符方法
    dictionaryConversion(code, options) {
        let yDatas: any;
        let datas = [];
        if (code) {
            yDatas = code.split(',');
            for (let i = 0; i < options.length; i++) {
                for (let j = 0; j < yDatas.length; j++) {
                    if (options[i].id == yDatas[j]) {
                        datas.unshift(options[i].text)
                    }
                }
            }
            if (datas.toString()) {
                return datas.toString();
            } else {
                return '';
            }
        }
        return '';
    }

    // 关闭按钮，关闭窗口
    handleBackClick() {
        this.tabServe.closeUrl('/kms/InstanceAdd', true);
        // this.tabServe.refurbis('/kms/InstanceQuery');
    }

    // 上传头像成功的回调
    headImgAdd(event){
        if (event.length > 0) {
            const val = event[0].filePath + event[0].fileName;
            this.fileThumbnail = val;
        }
    }

    // 删除头像成功的回调
    headImgDelete(event){
        this.fileThumbnail = '';
    }

    // 从素材库中选中图像
    selectImg(){
        
    }

    // 头部按钮点击事件
    clickToolbar(state,disabled){
        if(state != 'close' && disabled){
            this.message.waring('请检查所有必填项是否填写完整！');
            return;
        }
        switch(state){
            case 'addToTab': {
                // 保存信息并添加到tab页
                this.onSubmit('save',true);
                this.componentState.emit(state);
                break;
            }
            case 'save': {
                // 保存信息
                this.onSubmit('save');
                break;
            }
            case 'small': {
                this.componentState.emit(state);
                break;
            }
            case 'close': {
                this.componentState.emit(state);
                break;
            }
        }
    }

    // 点击属性名称存储属性信息为添加质检记录做准备
    setAttrRecord(i,m){
        if(this.params.addOrUpdate == 'Verify'){
            let item = this.baseInfoConfig[i][m];
            let verifyConfig = {
                uuid: this.instanceModuleService.uuid2(),
                contentName: item.attributeName,      // 属性名称
                contentModule: '著录信息',             // 错误模块
                foreignId: this.params.instanceId,  // 实体id
                contentId: item.attributeId,    // 属性id
                recordType: 1,    // 1 实体  2 标记
            }
            this.jwt.setToKen('instanceVerifyConfig',JSON.stringify(verifyConfig));
            this.message.info('选中属性：'+item.attributeName);
        }
    }

    // 当前实体质检通过或驳回，开始质检下一条
    verifyNext(event){
        if(event){
            this.message.info('操作成功！');
            this.refreshPage(event,'Verify');
        }else{
            this.message.info('所有待质检实体均已质检完成！');
            this.handleBackClick();
        }
    }

    // 处理文字特殊字符过滤器
    filterReplaceSpecial(str) {
        if (str) {
            let data = ''
            data = str.replace(/<\/?[^>]*>/g, '')
            data = data.replace(/&ldquo;/gi, '')
            data = data.replace(/&rdquo;/gi, '')
            data = data.replace(/&nbsp;/gi, '')
            data = data.replace(/&middot;/gi, '')
            return data ? data.length : 0;
        }else{
            return 0;
        }
    }
}